import React from 'react'
import {Link} from 'react-router'
import styles from './CollectionCard.scss'
import {Card} from 'common/styleguide/Card'
import {Distance, Elevation} from 'common/units'
import {Icon} from 'common/Icon'
import {Msg, commonNouns} from 'lib/localization'
import {missingPhoto} from 'lib/photoUtils'
import {urls} from 'lib/urls'
import _ from 'lodash'
import cx from 'classnames'

export class CollectionCard extends React.PureComponent {
  render () {
    const {collection: c, isMobile} = this.props

    return (
      <Card noPadding className={cx(styles.CollectionCard, isMobile && styles.collapsed)}>
        <Link to={urls.collections.show(c.id, c.privacyCode)}>
          <div className={styles.top}>
            {missingPhoto(c.cover)
              ? <Icon size={40} i='dynamic-feed' />
              : <img height='160' src={c.cover} />}
          </div>
          <div className={styles.bottom}>
            <h3>{c.title}</h3>
            <div className={styles.stats}>
              <div className={styles.distanceElevation}>
                <span><Distance bigUnits short value={_.get(c, 'stats.distance')} /></span>
                <span><Elevation short value={_.get(c, 'stats.elevation')} /></span>
              </div>
              <div className={styles.numItems}><Msg m={commonNouns.item} values={{count: c.stats.items}} /></div>
            </div>
          </div>
        </Link>
      </Card>
    )
  }
}
